// extracted by mini-css-extract-plugin
export default {"drawerDiv":"SideDrawer_drawerDiv__d2Lfm","drawerContent":"SideDrawer_drawerContent__zvpMh"};